var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"position-relative"},[_c('img',{staticClass:"avatar avatar-inline m-0",class:`s${_vm.imgSize}`,attrs:{"alt":_vm.reviewerAlt,"src":_vm.avatarUrl,"width":_vm.imgSize}}),_vm._v(" "),(_vm.hasMergeIcon)?_c('gl-icon',{staticClass:"merge-icon",attrs:{"name":"warning-solid","aria-hidden":"true"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }